import { createSelector } from 'reselect'

export const getSavePoint = (state) => state.savePoint
export const getCurrentSceneId = createSelector(
  [getSavePoint],
  (savePoint) => savePoint.currentSceneId
)
export const getElementsStatuses = createSelector(
  [getSavePoint],
  (savePoint) => savePoint.elementsStatuses
)
export const getChangingTurn = createSelector([getSavePoint], (savePoint) => savePoint.changingTurn)
